import {Component} from '@angular/core';


@Component({
	selector: 'index-page',
	template: `
		<cache-date></cache-date>
		
		Путь осилит идущий!
		
	`
})
export class IndexComponent {
	constructor() {
		
	}
}
